module.exports = __webpack_public_path__ + "static/0044-69838e29f8c2a4499cab8fdc0563aeae.png";